export default __webpack_public_path__ + "static/media/gg.adb94c9a.svg";